import { useState, useEffect } from 'react';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../context/AuthContext';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

const useWeeklySales = () => {
    const [sales, setSales] = useState([]);
    const { usuario } = useAuth();
    const now = Math.floor(Date.now() / 1000);
    const oneWeekAgo = now - (7 * 24 * 60 * 60);

    useEffect(() => {
        if (usuario) {
            const queryDB = query(
                collection(db, 'sales'),
                where('date', '>=', oneWeekAgo),
                where('date', '<=', now),
                where('userId', '==', usuario.uid)
            );

            const unsuscribe = onSnapshot(queryDB, (snapshot) => {
                if (!snapshot.empty) {
                    setSales(snapshot.docs.map((documento) => {
                        return { ...documento.data(), id: documento.id }
                    }));
                } else {
                    console.log("No sales data found for the last 7 days.");
                }
            }, (error) => {
                console.error("Error fetching sales data: ", error);
            });

            return unsuscribe;
        }
    }, [usuario, oneWeekAgo, now]);

    return sales;
}

export default useWeeklySales;
